import React from "react";
import qrLogo from "../assets/optimized/echo-logo-mark-96.webp";
import { WHATSAPP_START_URL } from "../siteConfig";
import LazyQrCode from "./LazyQrCode";
import { Icon } from "./Icon";
import { SiteFooter } from "./SiteFooter";

export const Contact = ({ data }) => {
  const email = data?.email || "echomsgteam@gmail.com";
  const qrTitle = data?.qrTitle || "Scan to start on your phone";
  const qrPill = data?.qrPill || "Use the camera app";
  const webTitle = data?.webTitle || "Continue on WhatsApp Web";
  const webPill = data?.webPill || "Opens in WhatsApp Web";

  return (
    <>
      <section id="contact" className="landing-section contact-start-section">
        <div className="container">
          <div className="contact-start-card">
            <div className="section-heading text-center contact-start-heading">
              <h2>{data?.title || "Get started"}</h2>
              <p>
                {data?.paragraph ||
                  "There's no app to download and no account to create. Just send Echo MSG a voice note, screenshot, or photo containing text."}
              </p>
            </div>

            <div className="contact-start-panels">
              <div className="contact-start-panel contact-start-panel-qr">
                <div className="contact-qr-shell">
                  <div className="contact-qr-frame">
                    <div className="contact-qr-code" aria-label="QR code to start Echo MSG on WhatsApp">
                      <LazyQrCode value={WHATSAPP_START_URL} />
                      <span className="contact-qr-logo-badge">
                        <img
                          src={qrLogo}
                          alt="Echo MSG logo"
                          className="contact-qr-logo-image"
                          decoding="async"
                          loading="lazy"
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <h3 className="contact-start-panel-title">{qrTitle}</h3>
                <span className="contact-start-pill">{qrPill}</span>
              </div>

              <div className="contact-start-divider" aria-hidden="true">
                <span>Or</span>
              </div>

              <div className="contact-start-panel contact-start-panel-web">
                <div className="contact-start-web-cta-wrap">
                  <a
                    href={WHATSAPP_START_URL}
                    className="btn btn-custom btn-lg contact-start-web-button"
                    data-analytics-label="contact_chat_on_whatsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="cta-whatsapp-icon" aria-hidden="true">
                      <Icon name="whatsapp" />
                    </span>
                    {data?.primaryCta || "Chat on WhatsApp"}
                  </a>
                </div>

                <h3 className="contact-start-panel-title">{webTitle}</h3>
                <span className="contact-start-pill contact-start-pill-muted">
                  {webPill}
                </span>
              </div>
            </div>

            <div className="contact-start-footer">
              <p className="contact-support-copy">
                {data?.secondaryText ||
                  "Questions about work use, client communication, or team rollout? Reach out directly."}
              </p>

              <a
                href={`mailto:${email}`}
                className="contact-link contact-email-chip"
                data-analytics-label="contact_email"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name="envelope" />
                <span>{email}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </>
  );
};
